SectionUserContent.Wizard = Class(
	/**
	 * @lends {SectionUserContent.Wizard#}
	 */
	{
		_step: 0,
		_totalSteps: 0,
		_nextDisabled: true,

		_id: 0,

		_taskType: null,
		_difficulty: null,
		_location: null,
		_image: {
			place: null,
			object: null
		},
		_question: {
			wrongAnswers: [],
			answer: ''
		},
		_eventId: 0,

		__construct: function(par) {
			par = par || {};
			this._eventId = Number(par.eventId) || 0;

			this.node = mkE({
				tag: 'div',
				id: 'user-content-wizard',
				els: [
					this._contentNode = mkE({
						tag: 'div',
						className: 'content'
					}),
					this._footerNode = mkE({
						tag: 'div',
						className: 'bottom',
						els: [
							mkE({
								tag: 'button',
								className: 'back',
								onclick: this._previousStep
							}),
							this._nextButton = mkE({
								tag: 'button',
								className: 'button button-pink button-large button-block button-disabled',
								onclick: this._continue,
								text: D.Lang.get('user-content-new.continue')
							})
						]
					})
				]
			});
			if (par.id) {
				this._id = par.id;
			}
			if (par.type) {
				this._taskType = par.type;
			}
			if (par.difficulty) {
				this._difficulty = par.difficulty;
			}
			if (par.location) {
				this._location = {
					position: par.location
				};
			}
			if (par.question) {
				this._question = par.question;
			}
			if (par.image) {
				this._image = par.image;
			}
			this._drawStep(this._step);
		},

		_getSteps: function() {
			let steps = [];
			if (!this._id) {
				steps.push({
					top: false,
					bottom: false,
					step: 'intro',
					content: this._selectIntro
				});
			}
			steps.push(
				{
					bottom: true,
					step: 'type',
					content: this._selectType
				},
				{
					bottom: true,
					step: 'location',
					content: this._selectLocation
				}
			);
			switch (this._taskType) {
				case 'image':
					steps.push({
						bottom: true,
						step: 'place-object-photo',
						content: this._selectPlaceObjectPhoto
					});
					break;
				case 'question':
					steps.push({
						bottom: true,
						step: 'question',
						content: this._enterQuestion
					});
					steps.push({
						bottom: true,
						step: 'place-photo',
						content: this._selectPlacePhoto
					});
					break;
				default:
					steps = steps.concat([{}, {}]);
					break;
			}
			steps.push({
				bottom: true,
				step: 'difficulty',
				content: this._selectDifficulty
			});
			steps.push({
				step: 'save',
				bottom: true,
				bottomText: D.Lang.get('user-content-new.save'),
				bottomAction: this._save,
				content: this._preview
			});
			return steps;
		},

		_currentStep: null,

		_drawStep: function(step) {
			clearNode(this._contentNode);
			let steps = this._getSteps();
			this._totalSteps = steps.length;
			let stepData = steps[step];
			if (stepData.top !== false) {
				this._drawHeader();
			}
			if (stepData.bottom) {
				this._showFooter();
			} else {
				this._hideFooter();
			}
			this._disableNext();
			if (stepData.bottomText) {
				setNodeText(this._nextButton, stepData.bottomText);
			} else {
				setNodeText(this._nextButton, D.Lang.get('user-content-new.continue'));
			}
			if (this._currentStep !== null) {
				removeClassName(this._contentNode, 'content-' + this._currentStep);
			}
			this._currentStep = stepData.step;
			addClassName(this._contentNode, 'content-' + this._currentStep);
			mkE.appendTypeElement(this._contentNode, stepData.content());
		},

		_drawHeader: function() {
			if (!this._totalSteps) {
				return;
			}
			let stepsNode = mkE({
				tag: 'div',
				className: 'steps container'
			}).append(this._contentNode);
			for (let i = -1; i < this._totalSteps; i++) {
				mkE({
					tag: 'div',
					className: 'step' + (i <= this._step ? ' step-active' : '')
				}).append(stepsNode);
			}
		},

		_showFooter: function() {
			this._footerNode.style.display = '';
		},

		_hideFooter: function() {
			this._footerNode.style.display = 'none';
		},

		_disableNext: function() {
			addClassName(this._nextButton, 'button-disabled');
			this._nextDisabled = true;
		},

		_enableNext: function() {
			removeClassName(this._nextButton, 'button-disabled');
			this._nextDisabled = false;
		},

		_previousStep: function() {
			let previousStep = this._step - 1;
			if (previousStep < 0) {
				this._exitWizard();
				return;
			}
			this._step = previousStep;
			this._drawStep(this._step);
		},

		_nextStep: function() {
			if (this._nextDisabled) {
				return;
			}
			let nextStep = this._step + 1;
			if (nextStep >= this._totalSteps) {
				return;
			}
			this._step = nextStep;
			this._drawStep(this._step);
		},

		_continue: function() {
			let steps = this._getSteps();
			let step = steps[this._step];
			if (!step.bottomAction) {
				this._nextStep();
				return;
			}
			step.bottomAction();
		},

		_exitWizard: function() {
			// TODO go back
			Section.navigate(D.url('user-content'));
		},

		_selectIntro() {
			this._enableNext();
			return [
				{
					tag: 'div',
					className: 'intro',
					els: [
						{
							tag: 'div',
							className: 'container',
							els: [
								{
									tag: 'h1',
									text: D.Lang.get('user-content-new.landing.title')
								},
								{
									tag: 'a',
									className: 'button button-pink button-large',
									text: D.Lang.get('user-content-new.landing.addTask'),
									onclick: this._nextStep
								}
							]
						}
					]
				}
			];
		},

		_selectType: function() {
			let re = [];
			re.push({
				tag: 'div',
				className: 'container',
				els: [
					{
						tag: 'div',
						className: 'title',
						text: D.Lang.get('user-content-new.chooseType')
					},
					new SectionUserContent.Wizard.Type({
						selected: this._taskType,
						types: [
							'image',
							'question'
						],
						onSelect: this._onTypeSelect
					})
				]
			});
			if (this._taskType) {
				this._enableNext();
			}
			return re;
		},

		_onTypeSelect: function(type) {
			this._taskType = type;
			this._enableNext();
		},

		_selectDifficulty() {
			let re = [];
			re.push({
				tag: 'div',
				className: 'container',
				els: [
					{
						tag: 'div',
						className: 'title',
						text: D.Lang.get('user-content-new.chooseDifficulty')
					},
					new SectionUserContent.Wizard.Difficulty({
						selected: this._difficulty,
						difficulties: [
							{type: 'easy', points: 2},
							{type: 'medium', points: 3},
							{type: 'hard', points: 5}
						],
						onSelect: this._onDifficultySelect
					}),
					{
						tag: 'div',
						className: 'info',
						els: [
							{
								tag: 'div',
								className: 'title',
								text: D.Lang.get('user-content-new.info')
							},
							{
								tag: 'p',
								innerHTML: D.Lang.get('user-content-new.difficulty.info')
							}
						]
					}
				]
			});
			if (this._difficulty) {
				this._enableNext();
			}
			return re;
		},

		_onDifficultySelect: function(difficulty) {
			this._difficulty = difficulty;
			this._enableNext();
		},

		_selectLocation: function() {
			if (this._location) {
				this._enableNext();
			}
			let re = [
				{
					tag: 'div',
					className: 'container',
					els: [
						{
							tag: 'div',
							className: 'title',
							text: D.Lang.get('user-content-new.selectLocation')
						}
					]
				},
				this._mapContainer = mkE({
					tag: 'div',
					className: 'map-container'
				})
			];
			let map = new SectionUserContent.Wizard.Map({
				onLocation: this._onLocationSelect,
				location: this._location
			});
			let mapNodes = map.getNodes();
			for (let i = 0, l = mapNodes.length; i < l; i++) {
				mapNodes[i].append(this._mapContainer);
			}
			return re;
		},

		_onLocationSelect: function(location) {
			this._location = location;
			this._enableNext();
		},

		_enterQuestion: function() {
			let re = [
				{
					tag: 'div',
					className: 'container',
					els: [
						{
							tag: 'div',
							className: 'title',
							text: D.Lang.get('user-content-new.enterQuestion')
						},
						this._questionInput = new T.Form.TextArea({
							caption: D.Lang.get('user-content-new.question'),
							placeholder: D.Lang.get('user-content-new.questionPlaceholder'),
							onChange: this._onQuestionChange,
							onInput: this._onQuestionChange,
							className: 'question-input',
							grow: true,
							value: this._question.question || '',
							border: true
						}),
						this._answerInput = new T.Form.Input({
							caption: D.Lang.get('user-content-new.correctAnswer'),
							placeholder: D.Lang.get(
								'user-content-new.correctAnswerPlaceholder'),
							onChange: this._onQuestionChange,
							onKeyUp: this._onQuestionChange,
							className: 'question-input',
							value: this._question.answer || '',
							border: true
						}),
						this._wrongAnswers = new SectionUserContent.Wizard.WrongAnswers({
							answers: this._question.wrongAnswers || [],
							onChange: this._onQuestionChange
						})
					]
				}
			];
			this._onQuestionChange();
			setTimeout(this._questionInput.focus, 100);
			return re;
		},

		_onQuestionChange: function() {
			let question = this._questionInput.value();
			this._question.question = question;

			let answer = this._answerInput.value();
			this._question.answer = answer;

			let answers = [];
			let answersValue = this._wrongAnswers.value();
			for (let i = 0, l = answersValue.length; i < l; i++) {
				if (!trim(answersValue[i])) {
					continue;
				}
				answers.push(answersValue[i]);
			}
			this._question.wrongAnswers = answers;

			if (question.length > 2 && answer.length > 0 && answers.length === 3) {
				this._enableNext();
			} else {
				this._disableNext();
			}
		},

		_selectPlacePhoto: function() {
			let re = [
				{
					tag: 'div',
					className: 'container',
					els: [
						{
							tag: 'div',
							className: 'title',
							text: D.Lang.get('user-content-new.selectPlacePhoto')
						},
						{
							tag: 'div',
							className: 'descr',
							text: D.Lang.get('user-content-new.selectPlacePhotoDescr')
						},
						{
							tag: 'div',
							className: 'image-upload-container',
							els: [
								this._placePhoto = new SectionUserContent.Wizard.Photo({
									onChange: this._onPlacePhoto,
									image: this._image.place,
									type: 9
								})
							]
						},
						{
							tag: 'div',
							className: 'info',
							els: [
								{
									tag: 'div',
									className: 'title',
									text: D.Lang.get('user-content-new.info')
								},
								{
									tag: 'p',
									innerHTML: D.Lang.get('user-content-new.placePhotoHelp')
								}
							]
						}
					]
				}
			];
			this._onPlacePhoto();
			return re;
		},

		_onPlacePhoto: function() {
			this._image.place = this._placePhoto.image;
			if (this._image.place) {
				this._enableNext();
			} else {
				this._disableNext();
			}
		},

		_selectPlaceObjectPhoto: function() {
			let re = [
				{
					tag: 'div',
					className: 'container',
					els: [
						{
							tag: 'div',
							className: 'title',
							text: D.Lang.get('user-content-new.selectPlaceObjectPhoto')
						},
						{
							tag: 'div',
							className: 'images',
							els: [
								{
									tag: 'div',
									className: 'image-upload-container',
									els: [
										this._objectPhoto = new SectionUserContent.Wizard.Photo({
											onChange: this._onPlaceObjectPhoto,
											image: this._image.object,
											type: 10
										}),
										{
											tag: 'div',
											className: 'help-text',
											els: [
												{
													tag: 'h5',
													text: D.Lang.get(
														'user-content-new.objectPhotoHelpTitle')
												},
												{
													tag: 'p',
													text: D.Lang.get('user-content-new.objectPhotoHelp')
												}
											]
										}
									]
								},
								{
									tag: 'div',
									className: 'image-upload-container',
									els: [
										this._placePhoto = new SectionUserContent.Wizard.Photo({
											onChange: this._onPlaceObjectPhoto,
											image: this._image.place,
											type: 9
										}),
										{
											tag: 'div',
											className: 'help-text',
											els: [
												{
													tag: 'h5',
													text: D.Lang.get(
														'user-content-new.placePhotoHelpTitle')
												},
												{
													tag: 'p',
													text: D.Lang.get('user-content-new.placePhotoHelp')
												}
											]
										}
									]
								}
							]
						},
						{
							tag: 'div',
							className: 'info',
							els: [
								{
									tag: 'div',
									className: 'title',
									text: D.Lang.get('user-content-new.info')
								},
								{
									tag: 'p',
									innerHTML: D.Lang.get('user-content-new.placeObjectPhotoHelp')
								}
							]
						}
					]
				}
			];
			this._onPlaceObjectPhoto();
			return re;
		},

		_onPlaceObjectPhoto: function() {
			this._image.object = this._objectPhoto.image;
			this._image.place = this._placePhoto.image;
			if (this._image.object && this._image.place) {
				this._enableNext();
			} else {
				this._disableNext();
			}
		},

		_preview: function() {
			this._enableNext();
			return [
				{
					tag: 'div',
					className: 'container',
					els: [
						{
							tag: 'div',
							className: 'title',
							text: D.Lang.get('user-content-new.preview')
						},
						this._getTaskPreview()
					]
				}
			];
		},

		_getTaskPreview: function() {
			if (this._taskType === 'image') {
				return this._getPhotoPreview();
			} else {
				return this._getQuestionPreview();
			}
		},

		_getPhotoPreview: function() {
			return mkE({
				tag: 'div',
				className: 'photo-preview',
				els: [
					new SectionUserContent.Wizard.PreviewMap(
						this._location,
						'imagematch',
						this._difficulty
					),
					{
						tag: 'div',
						className: 'grid grid-2',
						els: [
							{
								tag: 'div',
								className: 'image',
								style: {
									backgroundImage: `url('${this._image.object.image.large}')`
								}
							},
							{
								tag: 'div',
								className: 'image',
								style: {
									backgroundImage: `url('${this._image.place.image.large}')`
								}
							}
						]
					}
				]
			});
		},

		_getQuestionPreview: function() {
			let answers = [];
			for (let i = 0; i < this._question.wrongAnswers.length; i++) {
				const wrongAnswer = this._question.wrongAnswers[i];
				answers.push({
					tag: 'div',
					text: wrongAnswer
				});
			}
			answers.splice(getRandomInt(0, 3), 0, [
				{
					tag: 'div',
					className: 'correct',
					text: this._question.answer
				}
			]);
			return mkE({
				tag: 'div',
				className: 'question-preview',
				els: [
					{
						tag: 'div',
						className: 'grid grid-2',
						els: [
							new SectionUserContent.Wizard.PreviewMap(
								this._location,
								'question',
								this._difficulty
							),
							{
								tag: 'div',
								className: 'image',
								style: {
									backgroundImage: 'url(' + this._image.place?.image.large + ')'
								}
							}
						]
					},
					{
						tag: 'div',
						className: 'question',
						text: this._question.question
					},
					{
						tag: 'div',
						className: 'answers',
						els: [
							answers
						]
					}
				]
			});
		},

		_save: function() {
			this._disableNext();
			let data = {
				taskType: this._taskType,
				difficulty: this._difficulty,
				location: this._location.position,
				image: {},
				id: this._id
			};
			switch (this._taskType) {
				case 'image':
					if (this._image.place.isTmp) {
						data.image.place = {
							type: this._image.place.type,
							id: this._image.place.id
						};
					}
					if (this._image.object.isTmp) {
						data.image.object = {
							type: this._image.object.type,
							id: this._image.object.id
						};
					}
					break;
				case 'question':
					if (this._image.place.isTmp) {
						data.image.place = {
							type: this._image.place.type,
							id: this._image.place.id
						};
					}
					data.question = this._question;
					break;
			}
			new RPC('/api/web_rpc.php?EVENT_ID=' + this._eventId).send('saveUserContent', data, this._onSave);
		},

		_onSave: function(re) {
			this._enableNext();
			if (re && re.ok) {
				Section.navigate(D.url('user-content/my?success'));
			} else if (re && re.error === 'limit') {
				Section.navigate(D.url('user-content/my'));
			} else {
				alert(D.Lang.get('errors.system_error'));
			}
		}
	},
	mkE.Base
);

SectionUserContent.Wizard.Type = Class(
	/**
	 * @lends {SectionUserContent.Wizard.Type#}
	 */
	{
		_types: {},
		_selected: null,

		__construct: function(par) {
			this._onSelect = par.onSelect || D.doNothing;

			this.node = mkE({
				tag: 'div',
				className: 'types'
			});

			for (let i = 0, l = par.types.length; i < l; i++) {
				let type = par.types[i];
				// eh
				let taskType = type === 'image' ? 'matchmaker' : 'explorer';
				this._types[type] = mkE({
					tag: 'div',
					className: 'type',
					els: [
						{
							tag: 'div',
							className: 'radio'
						},
						{
							tag: 'div',
							els: [
								{
									tag: 'div',
									className: 'caption',
									text: D.Lang.get('user-content-new.types.' + type + '.title')
								},
								{
									tag: 'div',
									className: 'description',
									text: D.Lang.get(
										'user-content-new.types.' + type + '.description')
								}
							]
						},
						{
							tag: 'div',
							className: 'type-icon',
							els: [
								D.svgIcon('task-' + taskType)
							]
						}
					],
					onclick: D.closure(this, this._selectType, type)
				}).append(this.node);
			}
			if (par.selected) {
				this._selectType(par.selected);
			}
		},

		_selectType: function(selectedType) {
			this._selected = selectedType;
			for (let type in this._types) {
				if (!this._types.hasOwnProperty(type)) {
					continue;
				}
				if (type === selectedType) {
					addClassName(this._types[type], 'type-active');
				} else {
					removeClassName(this._types[type], 'type-active');
				}
			}
			this._onSelect(selectedType);
		}
	},
	mkE.Base
);

SectionUserContent.Wizard.Map = Class(
	/**
	 * @lends {SectionUserContent.Wizard.Map#}
	 */
	{
		_lastLocation: null,

		__construct: function(par) {
			this._onLocation = par.onLocation || D.doNothing;
			this._location = par.location;

			this.node = mkE({
				tag: 'div',
				className: 'map'
			});

			this._locate = mkE({
				tag: 'button',
				className: 'map-button locate',
				onclick: this._goToMyLocation
			});

			this._layer = mkE({
				tag: 'button',
				className: 'map-button map-satellite',
				onclick: this._toggleLayer
			});

			navigator.geolocation.getCurrentPosition(() => {
				console.log('Geolocation prepared');
			});
			D.loadGoogleMaps().then(this._onMap);
		},

		getNodes: function() {
			return [
				this.node,
				this._layer,
				this._locate
			];
		},

		_onMap: function() {
			let center = {
				lat: 56.927870,
				lng: 24.082226
			};
			if (this._location) {
				center = this._location.position;
			}
			this._map = new google.maps.Map(this.node, {
				center: center,
				zoom: 16,
				draggable: true,
				disableDefaultUI: true,
				clickableIcons: false,
				styles: D.MAP_STYLE
			});
			this._map.addListener('click', this._onMapClick);
			this._map.addListener('dragend', D.closure(this, function() {
				this._onMapMove();
			}));
			this._idleListener = this._map.addListener('idle', this._onIdle);
			if (navigator.geolocation) {
				this._watchLocation();
			}
		},

		_onIdle: function() {
			google.maps.event.removeListener(this._idleListener);
			if (!this._location) {
				this._centerMyLocation();
			} else {
				this._addMarker(new google.maps.LatLng(this._location.position.lat,
					this._location.position.lng), this._location.address);
			}
		},

		_toggleLayer() {

			if (this._map.getMapTypeId() === 'roadmap') {
				this._map.setMapTypeId('satellite');
				removeClassName(this._layer, 'map-satellite');
				addClassName(this._layer, 'map-roadmap');
			} else {
				this._map.setMapTypeId('roadmap');
				removeClassName(this._layer, 'map-roadmap');
				addClassName(this._layer, 'map-satellite');
			}
		},

		_goToMyLocation: function() {
			if (this._lastLocation) {
				this._addMarker(this._lastLocation, true);
				this._onLocation({
					position: this._lastLocation.toJSON(),
					address: ''
				});
				return;
			}
			this._centerMyLocation();
		},

		_centerMyLocation: function() {
			navigator.geolocation.getCurrentPosition(
				this._onGeolocation,
				error => {
					console.log(error);
				},
				{
					enableHighAccuracy: true,
					timeout: 5000,
					maximumAge: 30
				}
			);
		},

		_onGeolocation: function(position) {
			let pos = new google.maps.LatLng(position.coords.latitude,
				position.coords.longitude);
			this._lastLocation = pos;
			this._locate.style.display = 'block';
			if (this._mapMoved) {
				return;
			}
			if (!this._location) {
				this._addMarker(pos, true);
				this._onLocation({
					position: pos.toJSON(),
					address: ''
				});
			}
			this._setCenter(pos);
		},

		_watchLocation: function() {
			this._watch = navigator.geolocation.watchPosition(
				this._onGeolocationUpdate, this._onGeolocationError);
		},

		_onGeolocationUpdate: function(position) {
			let pos = new google.maps.LatLng(position.coords.latitude,
				position.coords.longitude);
			this._lastLocation = pos;
			this._locate.style.display = 'block';
			if (!this._myLocation) {
				this._myLocation = new google.maps.Marker({
					clickable: false,
					position: pos,
					map: this._map,
					icon: {
						url: '/assets/images/my-location.svg',
						size: new google.maps.Size(24, 24),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(12, 12)
					},
					zIndex: 4
				});
			} else {
				this._myLocation.setPosition(pos);
			}
		},

		_onGeolocationError: function(error) {
			if (error.code === 1) {
				this._locate.style.display = '';
				navigator.geolocation.clearWatch(this._watch);
			}
		},

		_onMapMove: function() {
			this._mapMoved = true;
		},

		_onMapClick: function(e) {
			this._onMapMove();
			this._addMarker(e.latLng);
			this._onLocation({
				position: e.latLng.toJSON(),
				address: ''
			});
		},

		_setCenter: function(latLng, zoom) {
			let scale = Math.pow(2, zoom === true ? 16 : this._map.getZoom());
			let worldCoordinateCenter = this._map.getProjection().
				fromLatLngToPoint(latLng);
			let pixelOffset = new google.maps.Point(0, (-40 / scale) || 0);
			let worldCoordinateNewCenter = new google.maps.Point(
				worldCoordinateCenter.x - pixelOffset.x,
				worldCoordinateCenter.y + pixelOffset.y
			);
			let newCenter = this._map.getProjection().
				fromPointToLatLng(worldCoordinateNewCenter);
			this._map.panTo(newCenter);
			if (zoom === true) {
				setTimeout(D.closure(this, function() {
					this._map.setZoom(16);
				}), 250);
			}
		},

		_addMarker: function(position, zoom) {
			if (this._marker) {
				this._removeMarker();
			}
			this._marker = new google.maps.Marker({
				position: position,
				map: this._map,
				draggable: true,
				icon: '/assets/images/marker-add.svg',
				animation: google.maps.Animation.DROP,
				zIndex: 5
			});
			this._marker.addListener('dragend', this._onMarkerDragEnd);
			this._setCenter(position, zoom === true);
			this._markerRadious = new google.maps.Circle({
				strokeWeight: 2,
				strokeColor: '#11CCA8',
				fillColor: '#00FFCE',
				fillOpacity: 0.2,
				map: this._map,
				center: position,
				radius: 120,
				zIndex: 4,
				clickable: false
			});

		},

		_onMarkerDragEnd: function() {
			let position = this._marker.getPosition();
			this._onLocation({
				position: position.toJSON(),
				address: ''
			});
			this._setCenter(position);
		},

		_removeMarker: function() {
			if (this._marker) {
				this._marker.setMap(null);
				delete this._marker;
			}
			if (this._markerRadious) {
				this._markerRadious.setMap(null);
				delete this._markerRadious;
			}
		}
	},
	mkE.Base
);

SectionUserContent.Wizard.WrongAnswers = Class(
	/**
	 * @lends {SectionUserContent.Wizard.WrongAnswers#}
	 */
	{
		__NAME: 'SectionUserContent.Wizard.WrongAnswers',

		_items: [],

		__construct: function(par) {
			par = par || {};
			this._onChange = par.onChange || D.doNothing;

			this.node = mkE({
				tag: 'div',
				className: 'wrong-answers',
				els: [
					this._itemsNode = mkE({
						tag: 'div',
						className: 'items'
					})
				]
			});

			if (empty(par.answers)) {
				let item = this._addItem('', 0);
				setTimeout(item.focus, 100);
				this._addItem('', 1);
				this._addItem('', 2);
			} else {
				for (let i = 0, l = 3; i < l; i++) {
					this._addItem(par.answers[i] || '', i);
				}
			}
		},

		_addItem: function(value, index) {
			let item = new SectionUserContent.Wizard.WrongAnswers.Item({
				caption: index === 0 ? D.Lang.get('user-content-new.wrongAnswers') : '',
				placeholder: D.Lang.get('user-content-new.wrongAnswerPlaceholder').
					replace('%NR%', index + 1),
				onChange: this._onChange,
				onRemove: this._onRemove,
				value: value
			});
			this._items.push(item);
			item.append(this._itemsNode);
			return item;
		},

		_onRemove: function(item) {
			this._items = this._items.filter(function(i) {
				return i !== item;
			});
			item.remove();
			if (this._items.length < 4) {
				this._moreNode.style.display = '';
			}
			this._onChange();
		},

		_addField: function() {
			if (this._items.length >= 4) {
				return;
			}
			let item = this._addItem(false, '');
			setTimeout(item.focus, 100);
			if (this._items.length >= 4) {
				this._moreNode.style.display = 'none';
			}
		},

		value: function() {
			let re = [];
			for (let i = 0, l = this._items.length; i < l; i++) {
				re.push(this._items[i].value());
			}
			return re;
		}
	},
	mkE.Base
);

SectionUserContent.Wizard.WrongAnswers.Item = Class(
	/**
	 * @lends {SectionUserContent.Wizard.WrongAnswers.Item#}
	 */
	{
		__NAME: 'SectionUserContent.Wizard.WrongAnswers.Item',

		__construct: function(par) {
			par = par || {};
			this._onChange = par.onChange || D.doNothing;
			this._onRemove = par.onRemove || D.doNothing;

			this._input = new T.Form.Input({
				onChange: this._onChange,
				onKeyUp: this._onChange,
				className: 'wrong-answer-input',
				value: par.value || '',
				remove: null,//par.caption ? null : this._remove,
				caption: par.caption,
				placeholder: par.placeholder,
				border: true
			});
			this.node = this._input.node;
		},

		_remove: function() {
			this._onRemove(this);
		},

		value: function() {
			return this._input.value();
		},

		focus: function() {
			this._input.focus();
		}
	},
	mkE.Base
);

SectionUserContent.Wizard.Photo = Class(
	/**
	 * @lends {SectionUserContent.Wizard.Photo#}
	 */
	{
		__NAME: 'SectionUserContent.Wizard.Photo',

		image: null,
		_doneTimeout: null,
		_type: null,

		__construct: function(par) {
			par = par || {};
			this._onChange = par.onChange || D.doNothing;
			this.image = par.image || null;
			this.originalImage = par.image || null;
			this._type = par.type || null;

			this.node = mkE({
				tag: 'div',
				className: 'content-photo content-photo-' + this._type
			});
			if (this.image) {
				this._showImage(true);
			} else {
				this._showUpload();
			}
		},

		_showImage: function(hideDone) {
			clearTimeout(this._doneTimeout);
			clearNode(this.node);
			let imageNode = mkE({
				tag: 'div',
				className: 'item-image',
				style: {
					backgroundImage: `url('${this.image.image.large}')`
				},
				onclick: () => {
					T.Popup.Gallery.open([this.image.image.large]);
				},
				els: [
					{
						tag: 'button',
						className: 'remove',
						onclick: this._onClickRemove,
						els: [D.svgIcon('trash')]
					}
				]
			}).append(this.node);
			if (hideDone !== true) {
				this._doneNode = mkE({
					tag: 'div',
					className: 'done',
					text: D.Lang.get('user-content-new.imageAdded')
				}).append(imageNode);
				this._doneTimeout = setTimeout(this._hideDone, 2000);
			}
		},

		_hideDone: function() {
			this._doneNode.style.opacity = 0;
			this._doneTimeout = setTimeout(this._removeDone, 250);
		},

		_removeDone: function() {
			this._doneNode.remove();
		},

		_onClickRemove: function(e) {
			e.cancelBubble = true;
			this.image = null;
			this._onChange(this.image);
			this._showUpload();
		},

		_showUpload: function() {
			clearTimeout(this._doneTimeout);
			clearNode(this.node);
			this._uploadNode = mkE({
				tag: 'div',
				className: 'content-upload',
				els: [
					{
						tag: 'div',
						className: 'image-container',
						els: [
							this._imageNode = mkE({
								tag: 'div',
								className: 'image',
								els: []
							})
						]
					}
				]
			}).append(this.node);
			this._initUploader();
		},

		_showAddImage: function() {
			clearNode(this._imageNode);
			this._imageNode.style.backgroundImage = '';
			mkE({
				tag: 'div',
				className: 'add-image',
				els: [
					D.svgIcon('task-matchmaker'),
					D.Lang.get('user-content-new.addImage')
				]
			}).append(this._imageNode);
			this._uploader.append(this._imageNode);
		},

		_showLoader: function() {
			clearNode(this._imageNode);
			this._imageNode.style.backgroundImage = '';
			mkE({
				tag: 'div',
				className: 'loading',
				els: [
					{
						tag: 'div',
						className: 'lds-ring',
						els: [
							{
								tag: 'div'
							},
							{
								tag: 'div'
							},
							{
								tag: 'div'
							}
						]
					},
					this._loaderText = mkE({
						tag: 'div',
						className: 'text-white',
						text: '...'
					})
				]
			}).append(this._imageNode);
		},

		_initUploader: function() {
			let p = new D.UploaderPar;
			if (D.browser.OS === 'Android') {
				p.accept = 'images/*';
			} else {
				p.accept = 'image/x-png,image/gif,image/jpeg';
			}
			p.log = false;
			p.thumbWidth = 328;
			p.thumbHeight = 185;
			p.onSelect = this._onSelect;
			p.onThumb = this._onThumb;
			p.onGetUploadData = this._onGetUploadData;
			p.onUploadCompleteData = this._onUploadData;
			p.onUploadIOError = this._onUploadError;
			p.onUploadProgress = (p) => {
				if(!this._loaderText) {
					return;
				}
				if (p.type === 'compression') {
					setNodeText(this._loaderText, D.Lang.get('user-content-new.compressing').replace('%PERCENT%', p.percent))
				} else {
					setNodeText(this._loaderText, D.Lang.get('user-content-new.uploading').replace('%PERCENT%', p.percent));
				}
			};
			p.compressionOptions = {
				maxWidthOrHeight: 2048,
				initialQuality: 0.8,
				preserveExif: true
			};
			/** @type {D.NativeUploader} */
			this._uploader = new Uploader(p);
			this._showAddImage();
		},

		_onSelect: function(par) {
			let ext = last(par.name.split('.'));
			ext = ext.toLowerCase();
			if (!in_array(ext, ['jpg', 'jpeg', 'png', 'gif'])) {
				this._uploadError(D.Lang.get('upload.errors.extension'));
				return;
			}
			this.uploading = true;
			addClassName(this._uploadNode, 'uploading');
			this._uploadError(null);
			this._showLoader();
		},

		_onThumb: function(data) {
			this._imageNode.style.backgroundImage = 'url(' + data.url + ')';
		},

		_onGetUploadData: function() {
			return {
				url: D.UPL + 'api.php',
				data: {
					type: this._type
				}
			};
		},

		_onUploadData: function(data) {
			removeClassName(this._uploadNode, 'uploading');
			this.uploading = false;
			data = D.JSON.decode(data.data);
			if (!data) {
				this._uploadError(D.Lang.get('upload.errors.general'));
				this._showAddImage();
				return;
			}
			if (data.error) {
				let errorText = D.Lang.get('upload.errors.general');
				if (data.errorNr === 204) {
					errorText = D.Lang.get('upload.errors.small');
				}
				this._uploadError(errorText);
				this._showAddImage();
				return;
			}
			this._onImage(data);
		},

		_onUploadError(par) {
			removeClassName(this._uploadNode, 'uploading');
			this.uploading = false;
			if (par && par.error === 'compression_error') {
				this._uploadError(D.Lang.get('upload.errors.compression_error'));
			} else {
				this._uploadError(D.Lang.get('upload.errors.general'));
			}
			this._showAddImage();
		},

		_uploadError: function(error) {
			if (this._uploadErrorNode) {
				this._uploadErrorNode.remove();
			}
			this._uploadErrorNode = T.error(error);
			if (error) {
				this._uploadErrorNode.prepend(this._uploadNode);
			}
		},

		_onImage: function(data) {
			this.image = data.pic;
			this.image.isTmp = true;
			this._onChange(this.image);
			this._showImage();
		}
	},
	mkE.Base
);

SectionUserContent.Wizard.PreviewMap = Class(
	/**
	 * @lends {SectionUserContent.Wizard.Map#}
	 */
	{
		/**
		 * @param {google.maps.LatLng} location
		 * @param {string} taskType
		 * @param {string} taskDifficulty
		 * @private
		 */
		__construct: function(location, taskType, taskDifficulty) {
			this._location = location;
			this._markerImage = `${taskType}-${taskDifficulty}`;

			this.node = mkE({
				tag: 'div',
				className: 'map map-preview'
			});

			D.loadGoogleMaps().then(this._onMap);
		},

		_onMap: function() {
			let center = this._location.position;
			this._map = new google.maps.Map(this.node, {
				center: center,
				zoom: 15,
				draggable: false,
				disableDefaultUI: true,
				clickableIcons: false,
				disableDoubleClickZoom: true,
				gestureHandling: 'none',
				keyboardShortcuts: false,
				scrollwheel: false,
				styles: D.MAP_STYLE
			});
			this._idleListener = this._map.addListener('idle', this._onIdle);
		},

		_onIdle: function() {
			google.maps.event.removeListener(this._idleListener);
			this._addMarker(new google.maps.LatLng(this._location.position.lat,
				this._location.position.lng));
		},

		_setCenter: function(latLng) {
			let worldCoordinateCenter = this._map.getProjection().
				fromLatLngToPoint(latLng);
			let worldCoordinateNewCenter = new google.maps.Point(
				worldCoordinateCenter.x,// - pixelOffset.x,
				worldCoordinateCenter.y// + pixelOffset.y
			);
			let newCenter = this._map.getProjection().
				fromPointToLatLng(worldCoordinateNewCenter);
			this._map.panTo(newCenter);
		},

		_addMarker: function(position) {
			new google.maps.Marker({
				position: position,
				map: this._map,
				draggable: false,
				icon: `/assets/images/markers/${this._markerImage}.svg`,
				animation: google.maps.Animation.DROP,
				zIndex: 5
			});
			new google.maps.Circle({
				strokeWeight: 2,
				strokeColor: '#11CCA8',
				fillColor: '#00FFCE',
				fillOpacity: 0.2,
				map: this._map,
				center: position,
				radius: 120,
				zIndex: 4,
				clickable: false
			});
			this._setCenter(position);
		}
	},
	mkE.Base
);

SectionUserContent.Wizard.Difficulty = Class(
	/**
	 * @lends {SectionUserContent.Wizard.Difficulty#}
	 */
	{
		_types: {},
		_selected: null,

		__construct: function(par) {
			this._onSelect = par.onSelect || D.doNothing;

			this.node = mkE({
				tag: 'div',
				className: 'difficulties'
			});

			for (let i = 0, l = par.difficulties.length; i < l; i++) {
				let difficulty = par.difficulties[i];
				this._types[difficulty.type] = mkE({
					tag: 'div',
					className: 'difficulty difficulty-' + difficulty.type,
					els: [
						{
							tag: 'div',
							className: 'image',
							els: [
								D.svgIcon('task-explorer')
							]
						},
						{
							tag: 'div',
							className: 'caption',
							text: D.Lang.get(
								'user-content-new.difficulty.' + difficulty.type + '.title')
						},
						{
							tag: 'div',
							className: 'points',
							text: D.Lang.get('user-content-new.difficulty.points').
								replace('%POINTS%', difficulty.points)
						},
						{
							tag: 'div',
							className: 'radio'
						}
					],
					onclick: D.closure(this, this._selectType, difficulty.type)
				}).append(this.node);
			}

			if (par.selected) {
				this._selectType(par.selected);
			}
		},

		_selectType: function(selectedType) {
			this._selected = selectedType;
			for (let type in this._types) {
				if (!this._types.hasOwnProperty(type)) {
					continue;
				}
				if (type === selectedType) {
					addClassName(this._types[type], 'difficulty-active');
				} else {
					removeClassName(this._types[type], 'difficulty-active');
				}
			}
			this._onSelect(selectedType);
		}
	},
	mkE.Base
);